jQuery(function(){

    //currently not used, but can be if needed

    var iframeSelector = ".lity-iframe.overlaykarte iframe";

    var eventBindings = {};

    window.pixelpoint.mapCommunications = {
        on: function(key, action){
            eventBindings[key] = action;
        },
        off: function(key){
            if(!!eventBindings[key])
            {
                delete eventBindings[key];
            }
        },
        trigger: function(key, data){
            var iframe = $(iframeSelector);
            if(iframe.length > 0){
                iframe.contentWindow.postMessage({
                    key:key,
                    data:data
                },"*");
            }
        }
    };

    window.onmessage = function(e){
        if(!!e.data && !!e.data.key && !!eventBindings[e.data.key]){
            var data = e.data.data || {};
            eventBindings[e.data.key](e.data.data);
        }
    };

    window.pixelpoint.mapCommunications.on("cookies.allowed", function(){
        var cookiesAllowed = "yes";
        if(!!readCookie("pp_supress_cookies")){
            cookiesAllowed = "no";
        }
        window.pixelpoint.mapCommunications.trigger("cookies.allowed",{"allowed":cookiesAllowed});
    });
});